<div *ngIf="title" class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
</div>

<div class="modal-body">
  <div class="overflow">
    {{ content }}
  </div>

  <div class="modal-footer text-right">
    <button class="btn btn-primary" (click)="closeModal()">
      Ok
    </button>
  </div>
</div>
